export default "{\n    \"emptyPlaceholder\": \"Select a Type\",\n    \"searchPlaceholder\": \"Search Types\"\n}\n"